<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：页面头部
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="main-header-container" class="main-header-container">
		<div class="left-container">
			<i @click="handleCollapseMenu" class="el-icon-s-grid collapse-icon"></i>
			<el-breadcrumb separator="/" class="breadcrumb-custom">
			  <el-breadcrumb-item v-for="item in tags" :key="item.id" :to="{ path: item.path }">{{ item.label }}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="div-class-label">{{ this.$route.meta.label }}</div>
		</div>
		<div class="right-container">
			<div class="user-name">{{ userInfo.realname }}</div>
			<el-dropdown @command="curUserACT" class="user-dropdown">
			  <div class="user-avatar-container">
				  <img src="../images/ico_gd.png" class="user-avatar" />
				  <i class="el-icon-caret-bottom avatar-caret"></i>
			  </div>
			  <el-dropdown-menu slot="dropdown" class="dropdown-menu-custom">
				<el-dropdown-item command="showUserInfo" class="dropdown-item-custom">
					<i class="el-icon-user"></i>
					<span>个人信息</span>
				</el-dropdown-item>
				<!-- <el-dropdown-item command="showUserAccessCode" class="dropdown-item-custom">
					<i class="el-icon-key"></i>
					<span>访问密钥</span>
				</el-dropdown-item> -->
				<el-dropdown-item command="logoutUser" class="dropdown-item-custom logout-item">
					<i class="el-icon-switch-button"></i>
					<span>退出</span>
				</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import { logoutUser } from '../api/'

// 输出元素
export default {
	name: 'main-header-container',
	props: ['userInfo'],
	data() {
		return {}
	},
	computed: {
		// 动态获得数据，与原数组 menuData 同名
		/*getUserName() {
			const curUserLogin = Cookies.get('curUserLogin');
			if(curUserLogin) {
				const { username } = JSON.parse(curUserLogin);
				return username;
			}
			else
			{
				return "未登录";
			}
		},*/
		...mapState({
			tags: state => state.tab.tabsList,
		}),
	},
	methods: {
		handleCollapseMenu(){
			//this.$store.commit('tab/collapseMenu');
			//document.getElementById("mainAside").style.display = "";
			document.getElementById("mainAside").classList.toggle('hidden');
			setTimeout(() => {
				//this.$store.commit('tab/collapseMenu');
			}, 0);
		},
		curUserACT(command) {
			//console.log(command);
			if(command === "showUserInfo") {
				//console.log('查看用户信息');
				this.$router.push('/myInfo');
			} else if(command === "logoutUser") {
				//console.log('退出当前登陆用户？');
				/*
				this.$confirm('是否退出当前用户，并返回到登陆页面？', '确认退出', {
				  distinguishCancelAndClose: true,
				  confirmButtonText: '退出',
				  cancelButtonText: '放弃'
				}).then(() => {*/
					const result = logoutUser({});
					if(parseInt(result.code) === 20000)
					{
						this.$message({
						  type: 'warning',
						  message: '退出成功！'
						});
					}
					else
					{
						this.$alert('在服务器退出登陆状态失败！', '退出失败', {
						  confirmButtonText: '确定',
						  callback: action => {
							this.$message({
								type: 'error',
								message: '退出失败，请联系管理员！'
							});
						  }
						});
					}
					Cookies.remove('selLoginOption');
					Cookies.remove('curUserLogin');
					//Cookies.remove('curUserMenu');
					localStorage.removeItem('curUserMenu');
					/*
					this.$alert('当前登陆用户已经退出！', '退出成功', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					*/
					this.$router.push('/login');
				/*
				}).catch(action => {
					this.$message({
					  type: 'info',
					  message: action === 'cancel'
						? '放弃保存并离开页面'
						: '停留在当前页面'
					});
					this.$message({
					  type: 'info',
					  message: '放弃退出，保持当前用户'
					});
				});*/
			} else if(command === "showUserAccessCode") {
				this.$router.push('/getaccesscode');
			}
		},
	},
	mounted() {
		//console.log("route:", this.$route);
		//console.log(this.tags, 'tags');
	},
}
</script>
<style lang="less" Scoped>
.main-header-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: calc(100% - 1px);
	padding: 0 20px;
	margin: 0px 0px;
	background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
	border-bottom: 1px solid #dcdfe6;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	overflow-x: auto;
	overflow-y: hidden;

	/* Webkit浏览器滚动条样式 */
	.main-header-container::-webkit-scrollbar {
	  height: 1px; /* 控制滚动条粗细 */
	}

	.main-header-container::-webkit-scrollbar-track {
	  background: rgba(236, 240, 241, 0.1);
	  border-radius: 5px;
	}

	.main-header-container::-webkit-scrollbar-thumb {
	  background: #aac8ff;
	  border-radius: 5px;
	  transition: all 3.3s ease;
	}

	.main-header-container::-webkit-scrollbar-thumb:hover {
	  background: #0099ff;
	}

	/* Firefox滚动条样式 */
	.main-header-container {
	  scrollbar-width: thin;
	  scrollbar-color: #ddeeff rgba(236, 240, 241, 0.1);
	}

	.left-container {
		display: flex;
		align-items: center;
		gap: 5px;
		cursor: pointer;
		padding-right: 20px;
	}

	.collapse-icon {
		font-size: 20px;
		color: #606266;
		cursor: pointer;
		padding: 8px;
		border-radius: 4px;
		transition: all 0.3s ease;
		
		&:hover {
			background-color: #f0f2f5;
			color: #409EFF;
		}
	}

	.breadcrumb-custom {
		/deep/ .el-breadcrumb__item {
			.el-breadcrumb__inner {
				color: #606266;
				font-weight: 500;
				transition: color 0.2s;
				
				&:hover {
					color: #409EFF;
				}
			}
			
			&:last-child .el-breadcrumb__inner {
				color: #303133;
				font-weight: 600;
			}
				cursor: pointer;
		}
		white-space: nowrap;
		width: 100%;
		display: flex;
		flex-wrap: nowrap;
	}

	.div-class-label {
		display: none;
		font-size: 16px;
		font-weight: 600;
		color: #303133;
		cursor: pointer;
	}

	.right-container {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.user-name {
		font-size: 14px;
		font-weight: 600;
		color: #ff9933;
		background: rgba(32, 79, 128, 0.3);
		padding: 6px 12px;
		border-radius: 16px;
	}

	.user-dropdown {
		cursor: pointer;
	}

	.user-avatar-container {
		position: relative;
		display: flex;
		align-items: center;
	}

	.user-avatar {
		width: 38px;
		height: 38px;
		border-radius: 50%;
		border: 0px solid #fff;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
		
		&:hover {
			border-color: #409EFF;
			box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
		}
	}

	.avatar-caret {
		margin-left: 2px;
		color: #909399;
		font-size: 12px;
	}

	.dropdown-menu-custom {
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		border: 1px solid #e6ebf5;
	}

	.dropdown-item-custom {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 15px;
		font-size: 14px;
		color: #606266;
		
		i {
			color: #909399;
		}
		
		&:hover {
			background-color: #f5f7fa;
			color: #409EFF;
			
			i {
				color: #409EFF;
			}
		}
	}

	.logout-item {
		color: #F56C6C;
		
		i {
			color: #F56C6C;
		}
		
		&:hover {
			background-color: #fef0f0;
			color: #F56C6C;
			
			i {
				color: #F56C6C;
			}
		}
	}

	@media (max-width: 600px) {
		.main-header-container {
			padding: 0 15px;
			background: rgb(30, 41, 59);
		}
		
		.left-container {
			color: #ffffff;
			i {
			}
		}
		.div-class-label {
			display: inline-block;
			cursor: pointer;
			color: #444444;
		}
		
		.breadcrumb-custom {
			display: none;
		}
		
		.user-name {
			font-size: 13px;
			padding: 4px 10px;
			width:110px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space:nowrap;
		}
		
		.collapse-icon {
			font-size: 18px;
			padding: 6px;
			color: #888888;
		}
	}
}
</style>